import { mapGetters } from 'vuex'
import { puedeVerNominaAdministrativa } from '@/utils/nominaPermisos'

export default {
  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),

    puedeVerNominaAdministrativa () {
      return puedeVerNominaAdministrativa(this.getdatosUsuarioERPERP)
    },
  },

  methods: {
    asegurarAccesoNominaAdministrativa () {
      if (this.puedeVerNominaAdministrativa) return true
      if (typeof this.validarError === 'function') {
        this.validarError('No tienes permiso para ver la nómina administrativa')
      }
      return false
    },
  },
}
